import React from "react"
import MenuItem from "@/components/common/Menus/MenuItem"
import styles from "@/styles/Manage.module.scss"

export const waitlistSettingsMenuOptions = [
  {
    default: true,
    label: "General",
    path: "/settings/general",
  },
  {
    label: "Notifications",
    path: "/settings/notifications",
  },
  {
    label: "Queues",
    path: "/settings/queues",
  },
  {
    label: "Custom Fields",
    path: "/settings/custom-fields",
  },
  {
    label: "Self Check-in",
    path: "/settings/self-check-in",
  },
  {
    label: "Virtual Waiting Room",
    path: "/settings/vwr",
  },
  {
    label: "Bookings",
    path: "/settings/bookings"
  },
  {
    label: "Public Waitlist",
    path: "/settings/public-waitlist"
  },
]

function WaitlistSettingsMenu() {
  return (
    <>
      <div className={styles.menu}>
        {waitlistSettingsMenuOptions.map((props, i) => (
          <MenuItem key={i} {...props} />
        ))}
      </div>
    </>
  )
}

export default WaitlistSettingsMenu
